import { graphQlClient } from "lib/graphql-client.js";
import Layout from "components/Layout";
import Blocks from "@/components/blocks/Blocks";
import { pageQuery, pagePathsQuery } from "lib/graphql/dynamic-page-queries";
import { fetchLayoutData, fetchLayoutDataServer } from "lib/api/strapi-layout";
import { findAndReplaceObjectKeys } from "utils/helpers/object-processing";
import styles from "../slug.module.scss";
import { site } from "config";

export default function DynamicPage({ pageData, layoutData }) {
  const SEO = {
    ...pageData?.seo,
    canonicalURL: `${site}${
      !!pageData?.page_type ? "/" + pageData?.page_type : ""
    }/${pageData?.slug}`,
  };

  return (
    <Layout layoutData={layoutData} seo={SEO}>
      <main className={`variable-container ${styles.page}`}>
        <Blocks content={pageData?.content_blocks} />
      </main>
    </Layout>
  );
}

export async function getStaticProps(context) {
  const { slug } = context.params;
  const client = graphQlClient();

  const pageResponse = await client.query({
    query: pageQuery,
    variables: {
      slug,
      publicationState:
        process.env.NEXT_PUBLIC_ENV.toLowerCase() === "preview" ||
        process.env.NEXT_PUBLIC_ENV.toLowerCase() === "local"
          ? "PREVIEW"
          : "LIVE",
    },
  });

  const pageAttributes = pageResponse.data.pages.data[0]?.attributes;
  const objectKeyRegex = new RegExp(/(___).*/gm);
  const content_blocks = pageAttributes?.content_blocks?.map((block) =>
    findAndReplaceObjectKeys(block, objectKeyRegex, "")
  );

  const pageData = {
    ...pageAttributes,
    content_blocks: content_blocks ?? null,
  };

  // const layoutData = await fetchLayoutData();
  const layoutData = await fetchLayoutDataServer();
  return {
    props: {
      pageData,
      layoutData,
    },
  };
}

export async function getStaticPaths() {
  const client = graphQlClient();

  const variables = {
    pageType: "about",
    publicationState:
      process.env.NEXT_PUBLIC_ENV.toLowerCase() === "preview" ||
      process.env.NEXT_PUBLIC_ENV.toLowerCase() === "local"
        ? "PREVIEW"
        : "LIVE",
  };

  const pageResponse = await client.query({
    query: pagePathsQuery,
    variables,
  });

  const paths = pageResponse.data.pages.data.map((page) => ({
    params: { slug: page.attributes.slug },
  }));

  return {
    paths,
    fallback: false,
  };
}
